import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';

import { CampaignTileView } from './components/CampaignTileView/CampaignTileView.jsx';
import { CampaignEditTileForm } from './components/CampaignEditTileForm.jsx';
import { CampaignNewTileForm } from './components/CampaignNewTileForm.jsx';
import { CampaignEditor } from './components/CampaignEditor.jsx';
import { CampaignsTable } from './components/CampaignsTable.jsx';
import { Preview } from './components/Preview/Preview.jsx';

export const Campaigns = () => {
  return (
    <HashRouter hashType="noslash">
      <Switch>
        <Route exact path="/">
          <CampaignsTable />
        </Route>
        <Route exact path="/archived">
          <CampaignsTable />
        </Route>

        <Route
          path="/:campaignId/tile/new"
          render={({ match: { params } }) => (
            <>
              <CampaignNewTileForm campaignId={params.campaignId} />
            </>
          )}
        />

        <Route
          path="/:campaignId/tile/:tileId"
          render={({ match: { params } }) => (
            <>
              <CampaignTileView
                tileId={params.tileId}
                campaignId={params.campaignId}
              />
            </>
          )}
        />
        <Route
          path="/:campaignId/edit/:tileId"
          render={({ match: { params } }) => (
            <>
              <CampaignEditTileForm
                tileId={params.tileId}
                campaignId={params.campaignId}
              />
            </>
          )}
        />

        <Route
          path="/:campaignId/preview"
          render={({ match: { params } }) => (
            <>
              <Preview id={params.campaignId} />
            </>
          )}
        />

        <Route
          exact
          path="/:campaignId"
          render={({ match: { params } }) => (
            <Redirect to={`/${params.campaignId}/edit`} />
          )}
        />

        <Route
          path="/:campaignId/edit"
          render={({ match: { params } }) => (
            <>
              <CampaignEditor id={params.campaignId} />
            </>
          )}
        />
      </Switch>
    </HashRouter>
  );
};
